/**
 * Which kind of device a record is, for the decisions every page makes about what to offer.
 *
 * One place, imported by modules that must not pull in anything that draws (`deviceAnalytics.ts` is
 * tested without a canvas), so the caption rule cannot drift between four copies again.
 */
import { ManagementChannel, type DeviceDto } from './contracts.gen.js';

export type DevicePlatform = 'windows' | 'synology' | 'linux' | 'android';

/**
 * False for a Synology, a generic Linux box or an Android phone. The caption prefix is a contract both
 * agents and the phone mapper keep; anything else, including no caption at all, reads as Windows so a
 * device enrolled before captions existed keeps its full page rather than silently losing tabs.
 */
export function isWindowsCaption(caption: string | null | undefined): boolean {
  if (!caption) return true;
  return !(caption.startsWith('Synology ') || caption.startsWith('Linux ') || caption.startsWith('Android'));
}

/** The channel decides a phone; the caption decides the rest. */
export function devicePlatform(device: Pick<DeviceDto, 'channel' | 'os'> | null | undefined): DevicePlatform {
  if (device?.channel === ManagementChannel.Android) return 'android';
  const caption = device?.os?.caption ?? '';
  if (caption.startsWith('Android')) return 'android';
  if (caption.startsWith('Synology ')) return 'synology';
  if (caption.startsWith('Linux ')) return 'linux';
  return 'windows';
}
